
<template>

  <div class="ui text container">
    <div class="ui segments">

      <!-- Website logo -->
      <div class="ui segment">
        <a href="/">
          <img width="75%" class="ui centered image" src="@/assets/images/7asanat-logo.png" />
        </a>
      </div>

      <div class="ui center aligned big segment">
        <span class="ui almarai primary text">
          شكرا لمشاركتكم في ختمة
          <br>
          <span class="ui almarai grey text">
            {{ ehdaa }}
          </span>
        </span>
      </div>

      <div class="ui center aligned big segment">

        <a class="ui big english label" @click="downloadPDF()">
          <span class="ui almarai text">عرض الآيات المختارة</span>
          <i class="quran icon" />
        </a>

        <h3 v-if="downloading" class="ui almarai grey header">
          جارٍ التحميل...
        </h3>

      </div>

      <div class="ui center aligned big segment">
        <span class="ui almarai primary text">
          تم اختيار أرباع الأحزاب التالية:
        </span>
      </div>

      <table class="ui almarai structured unstackable single line selectable table" :class="[isMobile() && 'tiny']">

        <thead>
          <tr>
            <th class="center aligned">الجزء</th>
            <th class="right aligned">ربع الحزب</th>
            <th class="right aligned">الآيات</th>
            <th class="center aligned">الصفحات</th>
          </tr>
        </thead>

        <QuarterRow v-for="quarter in selectedQuarters" :key="quarter.id" :quarter="quarter" />

      </table>

      <div class="ui center aligned segment">
        <a class="ui large english label" :href="`/khatmat/${khatmaID}`">

          <span class="ui almarai text">عودة إلى صفحة الختمة</span>
          <i class="undo alternate icon" />

        </a>
      </div>

    </div>
  </div>

</template>

<script>
import axios from 'axios';
import download from 'downloadjs';

import QuarterRow from '@/components/Khatmat/QuarterRow';

export default {

  name: 'KhatmaResult',
  components: {

    QuarterRow

  },
  data: () => ({

    khatmaID: '',
    ehdaa: '',
    selectedQuarters: [],

    downloading: false

  }),
  mounted() {

    if (!localStorage.getItem('khatmaID')) {

      window.location = '/';
      return;

    }

    this.khatmaID = localStorage.getItem('khatmaID');
    this.ehdaa = localStorage.getItem('ehdaa');
    this.selectedQuarters = JSON.parse(localStorage.getItem('selectedQuarters')).map((quarter) => {

      quarter.status = 'available';
      return quarter;

    });

    this.selectedQuarters.sort((a, b) => a.ordering - b.ordering);

    document.title = `ختمة قرآنية - ${this.ehdaa}`;

  },
  methods: {

    async downloadPDF() {

      this.downloading = true;

      const result = await axios.post(`${process.env.VUE_APP_BASE_URL}/khatmat/print-pdf`, {

        ehdaa: this.ehdaa,
        quarters: this.selectedQuarters

      }, { responseType: 'blob' });

      this.downloading = false;

      download(result.data, `ختمة قرآنية - ${this.ehdaa}.pdf`);

    }

  }

}
</script>

<style lang="scss" scoped>
table {
  pointer-events: none;

  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

thead th {
  position: sticky !important;
  top: -2px;
}

.label {
  background-color: white !important;
  color: #3c8c45 !important;

  box-shadow: 0 0 0 0.08em #3c8c45 !important;

  i {
    margin: 0 0 0 0.5em !important;
  }
}
</style>
